import { BaseModel } from '../BaseModel/BaseModel';
import { BaseProjectEntity, RawBaseProject } from './Types';
import { GalleryEntity } from '../Gallery/Types';
import { UserEntity } from '../User/Types';
import { PermissionEntity } from '../Permission/Types';
import { AddressEntity } from '../Address/Types';
import { AddressModel } from '../Address/AddressModel';
import { GalleryModel } from '../Gallery/GalleryModel';
import { UserModel } from '../User/UserModel';
import { PermissionModel } from '../Permission/PermissionModel';
import { FormatDate } from '@shared/Helpers/FormatValue/FormatDate/FormatDate';

export class BaseProjectModel
    extends BaseModel<RawBaseProject, BaseProjectEntity>
    implements BaseProjectEntity
{
    id: number = 0;
    title: string = '';
    lock: boolean = false;
    createdAt: string = new Date().toISOString();
    updatedAt: string = new Date().toISOString();
    targetDate: string = new Date(Date.now() + 86400000).toLocaleDateString(
        'en-CA'
    );
    deletedAt: string | null = null;
    address?: AddressEntity;
    galleries?: GalleryEntity[] = [];
    users?: UserEntity[] = [];
    permissions?: PermissionEntity[] = [];

    constructor(project?: RawBaseProject) {
        super();

        if (project) {
            this.initialize(project);
        }
    }

    initialize(project: RawBaseProject) {
        this.id = project.id;
        this.title = project.title;
        this.lock = project.lock;
        this.createdAt = project.created_at;
        this.updatedAt = project.updated_at;
        this.deletedAt = project.deleted_at;
        this.targetDate = project.target_date
            ? FormatDate(project.target_date)
            : this.targetDate;
        this.address = project.address
            ? new AddressModel(project.address)
            : undefined;

        this.galleries = project.galleries?.length
            ? project.galleries.map(gallery => new GalleryModel(gallery))
            : [];
        this.users = project.users?.length
            ? project.users.map(user => new UserModel(user))
            : [];
        this.permissions = project.permissions?.length
            ? project.permissions.map(
                  permission => new PermissionModel(permission)
              )
            : [];
    }

    parse(): RawBaseProject {
        return {
            id: this.id,
            title: this.title,
            created_at: this.createdAt,
            target_date: this.targetDate,
            updated_at: this.updatedAt,
            deleted_at: this.deletedAt,
            lock: this.lock,
            ...(this.address && { address: this.address.parse() }),
            ...(this.galleries && {
                galleries: this.galleries.map(gallery => gallery.parse()),
            }),
            ...(this.users && { users: this.users.map(user => user.parse()) }),
            ...(this.permissions && {
                permissions: this.permissions.map(permission =>
                    permission.parse()
                ),
            }),
        };
    }
}
